// extracted by mini-css-extract-plugin
module.exports = {"no-record-found":"DonutChart_no-record-found__zsGJf"};